import { useLayoutEffect, useRef } from 'react';
import ChatContent from './chat/ChatContent';
import AuthChatInput from '../../components/chat-input/AuthChatInput';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import { useAppDispatch } from '../../app/hooks';
import { resetAuthChat } from '../../store/slices/chats.slice';
import { clearAuthSession, getAuthUsernameParam } from '../../utils/authSession';

const AiAuthContainer = () => {
    const { pathname } = useLocation();
    const usernameFromUrl = getAuthUsernameParam();
    const dispatch = useAppDispatch();
    const clearedSessionRef = useRef<string | null>(null);
    const type = pathname.includes('/sign-up') ? 'sign-up' : 'sign-in';
    const { authMessages } = useSelector(
        (state: RootState) => state.chats
    );

    useLayoutEffect(() => {
        if (!usernameFromUrl) return;
        if (clearedSessionRef.current === usernameFromUrl) return;
        clearedSessionRef.current = usernameFromUrl;
        clearAuthSession();
        dispatch(resetAuthChat());
    }, [usernameFromUrl, dispatch]);
    return (
        <div className='mt-auto flex justify-center max-w-full w-full'>
            <div className='my-2 flex flex-col  w-[80%]'>
                <div className='w-full bg-primary-default py-2 px-5 flex flex-wrap items-center text-white text-sm md:text-xl font-bold'>
                    <img alt='avatar' className='mr-4 w-10 h-10 object-cover rounded-full' src='/assets/agents/claire-agent-icon.svg' />
                    Claire
                </div>
                <ChatContent type={type} usernameFromUrl={usernameFromUrl} />
                <div className='p-5 border border-gray-100'>
                    {!!authMessages.length && (
                        <AuthChatInput type={type} usernameFromUrl={usernameFromUrl} />
                    )}
                </div>
            </div>
        </div>
    )
}

export default AiAuthContainer;